import React, { useEffect, useState } from 'react'
import { Button, Form, Image, Input, message, Modal, Row, Space } from 'antd'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import {
  LockOutlined,
  LoadingOutlined,
  MailOutlined,
  UserOutlined,
  GiftOutlined
} from '@ant-design/icons'
import { useLocation, useNavigate } from 'react-router-dom'

import ILSuccess from 'src/assets/images/il-success.png'

const _Register = ({ dispatch, register, loading }) => {
  const { state } = useLocation()
  const [form] = Form.useForm()
  const [visible, setVisible] = useState(false)

  const navigation = useNavigate()

  useEffect(() => {
    state === null && message.error('Please select package of pricing', 2, () => navigation('/'))
  }, [])

  useEffect(() => {
    if (register === 'success') {
      setVisible(true)
      form.resetFields()
    }
  }, [register])

  const onHandleRegister = () => {
    form.validateFields().then(response => {
      const forms = { ...response }
      forms.registerAs = state

      dispatch({
        type: 'credentials/credential_register',
        payload: {
          params: forms
        }
      })
    })
  }

  const onHandleRedirect = async (params) => {
    navigation(params)
    await dispatch({
      type: 'credentials/set_state',
      payload: {
        register: false
      }
    })
  }

  return (
    <div className='main'>
      <section
        className='hero-section ptb-100 background-img full-screen'
        style={{
          backgroundImage: "url('img/hero-bg-1.jpg')",
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
          backgroundSize: 'cover'
        }}
      >
        <div className='container'>
          <div className='row align-items-center justify-content-between pt-5 pt-sm-5 pt-md-5 pt-lg-0'>
            <div className='col-md-7 col-lg-6'>
              <div className='hero-content-left text-white'>
                <h1 className='text-white'>Create Your Account</h1>
                <p className='lead'>
                  Keep your face always toward the sunshine - and shadows will
                  fall behind you.
                </p>
              </div>
            </div>
            <div className='col-md-5 col-lg-5'>
              <div className='card login-signup-card shadow-lg mb-0'>
                <div className='card-body px-md-5 py-5'>
                  <div className='mb-5'>
                    <h6 className='h3'>Create account</h6>
                    <p className='text-muted mb-0'>
                      Made with love by developers for developers.
                    </p>
                  </div>
                  <Form
                    className='login-signup-form'
                    form={form}
                    onFinish={onHandleRegister}
                    layout='vertical'
                  >
                    <Form.Item
                      name='fullName'
                      label='Full Name'
                      rules={[{ required: true }]}
                    >
                      <Input
                        prefix={<UserOutlined className='mr-2' />}
                        className='form-control'
                        placeholder='Enter your fullname'
                      />
                    </Form.Item>
                    <Form.Item
                      name='username'
                      label='Username'
                      rules={[{ required: true }]}
                    >
                      <Input
                        prefix={<UserOutlined className='mr-2' />}
                        className='form-control'
                        placeholder='Enter your username'
                      />
                    </Form.Item>
                    <Form.Item
                      name='email'
                      label='Email Address'
                      rules={[{ required: true }]}
                    >
                      <Input
                        className='form-control'
                        placeholder='Enter your email@address'
                        prefix={<MailOutlined className='mr-2' />}
                      />
                    </Form.Item>
                    <Form.Item
                      name='password'
                      label='Password'
                      extra='password must have lower, upper & number.'
                      hasFeedback
                      rules={[{ required: true }]}
                    >
                      <Input.Password
                        className='form-control'
                        placeholder='Enter your password'
                        prefix={<LockOutlined className='mr-2' />}
                      />
                    </Form.Item>
                    <Form.Item
                      name='confirmPassword'
                      label='Confirm Password'
                      hasFeedback
                      extra='password must have lower, upper & number.'
                      dependencies={['password']}
                      rules={[
                        {
                          required: true,
                          message: 'Please confirm your password!'
                        },
                        ({ getFieldValue }) => ({
                          validator (_, value) {
                            if (!value || getFieldValue('password') === value) {
                              return Promise.resolve()
                            }

                            return Promise.reject(new Error('The two passwords that you entered do not match!'))
                          }
                        })
                      ]}
                    >
                      <Input.Password
                        className='form-control'
                        placeholder='Enter your confirm password'
                        prefix={<LockOutlined className='mr-2' />}
                      />
                    </Form.Item>
                    <Form.Item
                      name='referralCode'
                      label='Referral Code'
                    >
                      <Input
                        prefix={<GiftOutlined className='mr-2' />}
                        className='form-control'
                        placeholder='Enter your refferal code'
                      />
                    </Form.Item>

                    <button
                      type='submit'
                      className='btn btn-lg btn-block solid-btn border-radius mt-4 mb-3'
                      id='signIn'
                      disabled={loading}
                    >
                      {loading ? <LoadingOutlined /> : 'Register Now'}
                    </button>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='bottom-img-absolute'>
          <img src='img/wave-shap.svg' alt='wave shape' className='img-fluid' />
        </div>
      </section>
      <Modal
        centered
        visible={visible}
        title={false}
        closable={false}
        footer={false}
      >
        <div className='text-center'>
          <Image
            src={ILSuccess}
            preview={false}
            style={{ width: 200 }}
          />
          <div className='text-center mb-5'>
            <p className='mt-4 h3'>
              Registration Success!
            </p>
            <p className='mt-3'>
              Verify your email address to sign in,
              <br /> lorem ipsum dolar set amet anuesi karisema
              <br /> ipsum same nanie
            </p>
          </div>
          <Row justify='center'>
            <Space>
              <Button onClick={() => onHandleRedirect('/login')} type='primary'>
                Sign In
              </Button>
              <Button onClick={() => setVisible(!visible)}>
                Register Again
              </Button>
            </Space>
          </Row>
        </div>
      </Modal>
    </div>
  )
}

const mapStateToProps = ({ reducerCredentials }) => {
  return { ...reducerCredentials }
}

export const Register = connect(mapStateToProps)(_Register)

_Register.propTypes = {
  dispatch: PropTypes.func,
  loading: PropTypes.bool,
  register: PropTypes.string
}
